import { render, staticRenderFns } from "./SubjectList.vue?vue&type=template&id=bbf9a55c&scoped=true&"
import script from "./SubjectList.vue?vue&type=script&lang=js&"
export * from "./SubjectList.vue?vue&type=script&lang=js&"
import style0 from "./SubjectList.vue?vue&type=style&index=0&id=bbf9a55c&lang=scss&scoped=true&"
import style1 from "./SubjectList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf9a55c",
  null
  
)

export default component.exports